"use strict";import{IconCCLibrary as r}from"../src/elements/IconCCLibrary.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cclibrary",r);
//# sourceMappingURL=sp-icon-cclibrary.js.map
